<template>
  <div class="home">
    <!-- 学校网站头部导航 -->
    <SchoolHeader />
    
    <!-- 学校横幅区域 -->
    <SchoolBanner />
    
    <!-- 主要内容区域 -->
    <section class="main-content">
      <div class="content-container">
        <!-- 新闻和通知区域 -->
        <NewsSection />
        
        <!-- 学生和科技区域 -->
        <StudentsSection />
        
        <!-- 教师和党群区域 -->
        <TeachersSection />
        
        <!-- 底部专题和资源链接区域 -->
        <HomeBottomTu />
        
      </div>
    </section>
    
    <!-- 底部导航 -->
    <FooterNav />
  </div>
</template>

<script>
import SchoolHeader from '../components/SchoolHeader.vue'
import SchoolBanner from '../components/SchoolBanner.vue'
import NewsSection from '../components/NewsSection.vue'
import StudentsSection from '../components/StudentsSection.vue'
import TeachersSection from '../components/TeachersSection.vue'
import HomeBottomTu from '../components/homeBottomTu.vue'
import FooterNav from '../components/FooterNav.vue'

export default {
  name: 'HomePage',
  components: {
    SchoolHeader,
    SchoolBanner,
    NewsSection,
    StudentsSection,
    TeachersSection,
    HomeBottomTu,
    FooterNav
  },
  mounted(){
    console.log('process.env.VUE_APP_API_BASE_URL',process.env.VUE_APP_API_BASE_URL);
  }
}
</script>

<style scoped>
.home {
  padding: 0;
  background: #f5f5f5;
}

.main-content {
  background: #f5f5f5;
  padding: 30px 0;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}


</style>
